/* RESPONSIBLE TEAM: team-ai-agent */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import { hideIntercomWidgetWhenLoaded } from 'embercom/lib/intercom-widget-helper';

class StandaloneSimulationsRoute extends Route {
  @service appService: any;
  @service router: any;

  beforeModel() {
    if (!this.appService.app.canUseSophisticatedTestingCentralisedPage) {
      this.router.transitionTo('apps.app.standalone.testing');
    }
  }

  activate() {
    hideIntercomWidgetWhenLoaded();
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneSimulationsRoute);
